/**
 * 사건 하나를 씬으로 세운다 — **게임 본편의 단 하나뿐인 분기점.**
 *
 * `main.ts` 는 어느 집인지 몰라도 된다. **방이 알려 준 사건 id** 를 넘기면
 * 여기서 빌더를 고른다. 지금 에피소드는 사흘 하나라 빌더도 `world.ts` 하나다.
 * 새 에피소드가 다른 빌더를 쓰면 여기서 가른다 — 캐스팅(`as unknown as`)으로
 * 빈 필드를 숨기지 말고 `EpisodeScene` 을 전부 채울 것.
 */

import * as THREE from 'three';
import { buildWorld, type BuiltWorld } from './world';

/** 사건마다 있고 없고가 다른 것들. 없으면 빈 값으로 메워 `main.ts` 가 분기하지 않게 한다 */
export interface EpisodeScene extends BuiltWorld {
  /** 매 프레임 — 촛불 흔들림 같은 것. 사흘은 여기서 할 일이 없다 */
  /** `viewer` 를 주면 촛불 광원이 그쪽 가까운 것부터 켜진다 */
  update: (t: number, viewer?: THREE.Vector3) => void;
  /**
   * 플레이어가 선 층을 알린다. **그 층의 충돌체만 켜진다.**
   *
   * 이걸 아무도 안 부르고 있었다. 그래서 지하 우리의 벽이 지상에서도 막고
   * 있었고, 문이 멀쩡히 열려 있는데 방을 못 나갔다 — 눈에 보이지 않는
   * 다른 층의 벽에 부딪히고 있었던 것이다.
   */
  setFloor: (id: string) => void;
}

export function buildEpisodeScene(
  scene: THREE.Scene,
  renderer: THREE.WebGLRenderer,
  _episode: string | undefined,
  clusteredPoints = false,
): EpisodeScene {
  // 사흘은 프레임마다 할 일이 없다 — 눈과 조명은 각자 제 루프를 돈다
  // 사흘은 층이 하나라 층 전환이 없다
  return { ...buildWorld(scene, renderer, { batchPieces: true, clusteredPoints }), update: () => {}, setFloor: () => {} };
}
